import validate from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45check_45auth_45global from "/usr/code/docker/www/formx/client/middleware/01.check-auth.global.js";
import api_45redirect_45global from "/usr/code/docker/www/formx/client/middleware/api-redirect.global.js";
import custom_45domain_45global from "/usr/code/docker/www/formx/client/middleware/custom-domain.global.js";
import feature_45flags_45global from "/usr/code/docker/www/formx/client/middleware/feature-flags.global.js";
import manifest_45route_45rule from "/usr/code/docker/www/formx/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45check_45auth_45global,
  api_45redirect_45global,
  custom_45domain_45global,
  feature_45flags_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/usr/code/docker/www/formx/client/middleware/admin.js"),
  auth: () => import("/usr/code/docker/www/formx/client/middleware/auth.js"),
  guest: () => import("/usr/code/docker/www/formx/client/middleware/guest.js"),
  moderator: () => import("/usr/code/docker/www/formx/client/middleware/moderator.js"),
  "self-hosted-credentials": () => import("/usr/code/docker/www/formx/client/middleware/self-hosted-credentials.js"),
  "self-hosted": () => import("/usr/code/docker/www/formx/client/middleware/self-hosted.js"),
  subscribed: () => import("/usr/code/docker/www/formx/client/middleware/subscribed.js")
}